import React, {useContext, useState} from 'react'
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";
import {Product} from "../contexts/types";

type useUnknownProductType = {
    isProductUnknown: boolean
    setIsProductUnknown: React.Dispatch<boolean>
    unknownProduct: Product
}

const useUnknownProduct = (_isProductUnknown: boolean): useUnknownProductType => {
    const [isProductUnknown, setIsProductUnknown] = useState<boolean>(_isProductUnknown)
    const {t} = useContext(OrgCustomizationContext)

    return {
        isProductUnknown,
        setIsProductUnknown,
        unknownProduct: {
            action: '',
            categories: null,
            materialPrice: '',
            materialPriceCurrency: '',
            productId: 'XUN001',
            productName: t('ps_unknown'),
            salesOrg: '',
            shortDescription: t('ps_product_name_or_number_unknown'),
            validFrom: '',
            isDiscontinuedOrUnknown: true,
            isFirstPartyManufactured: true
        }
    }
}

export default useUnknownProduct
